import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { change_Lang } from "../../actions/Helper_action";
import { Create_Admin } from "../../actions/Admin_action";
import Swal from "sweetalert2";
import { Button, Input, Popover } from "antd";
const CreateAdmin = ({ handleCancel }) => {
  const dispatch = useDispatch();
  const [fname, setfname] = useState("");
  const [lname, setlname] = useState("");
  const [phone, setphone] = useState(0);
  const [password, setpassword] = useState("");
  const onCreateAdmin = () => {
    const user = {
      fname,
      lname,
      phone,
      password,
    };
    if (fname === "" || lname === "" || phone === "" || password === "") {
      Swal.fire({
        title: "OPS",
        text: dispatch(change_Lang("Please Check Inputs")),
        icon: "error",
        html: `<b class="fk">${dispatch(
          change_Lang("Please Check Inputs")
        )}</b>`,
        confirmButtonText: dispatch(change_Lang("Ok")),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1300,
      });
    } else {
      dispatch(Create_Admin(user));
      handleCancel();
      New_Page();
      Swal.fire({
        title: "Good job!",
        html: `<b class="fk">${dispatch(
          change_Lang("You successfully tainted your work")
        )}</b>`,
        icon: "success",
        confirmButtonText: dispatch(change_Lang("success")),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1000,
      });
    }
  };
  const New_Page = () => {
    setlname("");
    setfname("");
    setphone(0);
    setpassword("");
  };
  return (
    <>
      <div className="row">
        <div className="col-md-3 mt-2">
          <div className="form-group input-container">
            <label
              className="   fk d-flex justify-content-center"
              style={{
                fontSize: "16px",
                color: "#4064d7",
                fontWeight: "bold",
              }}
            >
              <i class="far fa-user"></i>&nbsp;
              {dispatch(change_Lang("profile_fname"))}
            </label>
            <Input
              name="fname"
              value={fname}
              type="text"
              addonBefore={
                <>
                  <Popover
                    content={
                      <div className="text-center">
                        <span className="fk" style={{ fontSize: "14px" }}>
                          {"ناوی یەکەمی بەڕێوبەر داخڵبکە"}
                        </span>
                        <br />
                        <span className="text-center">نمونە : محمد</span>
                      </div>
                    }
                  >
                    <span className=" py-0 px-0">
                      <i class="fas fa-info-circle"></i>
                    </span>
                  </Popover>
                </>
              }
              size="middle"
              onChange={(e) => setfname(e.target.value)}
              required
              autoComplete="off"
              style={{
                fontSize: "16px",
                borderBottomColor: "#3889c1",
              }}
            />
          </div>
        </div>
        <div className="col-md-3 mt-2">
          <div className="form-group input-container">
            <label
              className="   fk d-flex justify-content-center"
              style={{
                fontSize: "16px",
                color: "#4064d7",
                fontWeight: "bold",
              }}
            >
              <i class="far fa-user"></i>&nbsp;
              {dispatch(change_Lang("profile_lname"))}
            </label>
            <Input
              name="lname"
              type="text"
              value={lname}
              onChange={(e) => setlname(e.target.value)}
              required
              autoComplete="off"
              style={{
                fontSize: "16px",
                borderBottomColor: "#3889c1",
              }}
              addonBefore={
                <>
                  <Popover
                    content={
                      <div className="text-center">
                        <span className="fk" style={{ fontSize: "14px" }}>
                          {"ناوی دووەمی بەڕێوبەر داخڵ بکە"}
                        </span>
                        <br />
                        <span className="text-center">نمونە : عبدوللە عمر</span>
                      </div>
                    }
                  >
                    <span className=" py-0 px-0">
                      <i class="fas fa-info-circle"></i>
                    </span>
                  </Popover>
                </>
              }
            />
          </div>
        </div>
        <div className="col-md-3 mt-2">
          <div className="form-group input-container">
            <label
              className="   fk d-flex justify-content-center"
              style={{
                fontSize: "16px",
                color: "#4064d7",
                fontWeight: "bold",
              }}
            >
              <i class="fa fa-phone" aria-hidden="true"></i>&nbsp;
              {dispatch(change_Lang("phone_number"))}
            </label>
            <Input
              type="number"
              size="middle"
              value={phone === 0 ? "" : phone}
              onChange={(e) => setphone(e.target.value)}
              required
              autoComplete="off"
              style={{
                fontSize: "16px",
                borderBottomColor: "#3889c1",
              }}
              addonBefore={
                <>
                  <Popover
                    content={
                      <div className="text-center">
                        <span className="fk" style={{ fontSize: "14px" }}>
                          {
                            "ژمارەی مۆبایلی بەڕێوبەر داخڵبکە وە بەو ژمارە مۆبایلە داخڵ دەبێت "
                          }
                        </span>
                        <br />
                        <span className="text-center">نمونە : 00000097455</span>
                      </div>
                    }
                  >
                    <span className=" py-0 px-0">
                      <i class="fas fa-info-circle"></i>
                    </span>
                  </Popover>
                </>
              }
            />
          </div>
        </div>
        <div className="col-md-3 mt-2">
          <div className="form-group input-container">
            <label
              className="   fk d-flex justify-content-center"
              style={{
                fontSize: "16px",
                color: "#4064d7",
                fontWeight: "bold",
              }}
            >
              <i class="fa fa-lock" aria-hidden="true"></i>&nbsp;
              {dispatch(change_Lang("password"))}
            </label>
            <Input
              name="text"
              size="middle"
              type="password"
              value={password}
              onChange={(e) => setpassword(e.target.value)}
              autoComplete="off"
              style={{
                fontSize: "16px",
                borderBottomColor: "#3889c1",
              }}
              addonBefore={
                <>
                  <Popover
                    content={
                      <div className="text-center">
                        <span className="fk" style={{ fontSize: "14px" }}>
                          {"ژمارەی نهێنی بەڕێوبەر داخڵ بکە"}
                        </span>
                        <br />
                        <span className="text-center">نمونە : 55yuc---</span>
                      </div>
                    }
                  >
                    <span className=" py-0 px-0">
                      <i class="fas fa-info-circle"></i>
                    </span>
                  </Popover>
                </>
              }
            />
          </div>
        </div>
      </div>
      <br />
      <div className="d-flex justify-content-center">
        {" "}
        <Button
          className="ml-4 fk px-4"
          type="primary"
          shape="round"
          style={{
            background: "#d7e4eb",
            color: "#4b85a4",
            border: "none",
            outline: "none",
          }}
          htmlType="submit"
          onClick={() => {
            onCreateAdmin();
          }}
        >
          {dispatch(change_Lang("save"))}&nbsp;
          <i class="fas fa-save"></i>
        </Button>
        &nbsp; &nbsp; &nbsp;
        <Button
          className="ml-2 fk px-3"
          shape="round"
          style={{
            background: "#fff",
            color: "#000",
            border: "1px solid grey",
            outline: "none",
          }}
          onClick={New_Page}
        >
          {dispatch(change_Lang("new_page"))}&nbsp;
          <i class="fa fa-newspaper-o" aria-hidden="true"></i>
        </Button>
      </div>
    </>
  );
};

export default CreateAdmin;
